/**
 * Created by rhinov15 on 29/01/2016.
 */
/**
 * uiState for plan visualisation (mother class is UiState)
 */
import { UiState, UiStateEnum } from "./UiState";
import { EntityManager } from "../../plan/EntityManager";
import { GameObjectManager } from "../../plan/GameObjectManager";
import { Entity, Joinery, math, Room, TechnicalElement, Wall } from "@rhinov/savane-js";

export class VisualisePlanState extends UiState {
    constructor(cursorPosition: math.vec3 | null, cocosPosition: math.vec3 | null) {
        super(cursorPosition, cocosPosition);
    }

    // Return uiState enum value
    getUiState(): number {
        return UiStateEnum.uiVisualisePlanState;
    }

    // Mouse moved in VisualisePlanState, store cursor position
    moveMouseCursor(cursorPosition: math.vec3, cocosPos: math.vec3): UiState | null {
        this.cursorPosition = cursorPosition;
        this.cocosPosition = cocosPos;
        // Call parent setSelected method (not override here)
        this.setSelected();
        // Call what to do next and check if we stay in current state
        if (this.getNextUiState() === this.getUiState()) {
            // Yes we stay in the current state don't do anything, just return null
            return null;
        }
        else {
            // No, we go to another state, create it and return it (created in parent class)
            return this.createNextUiState();
        }
    }

    // What to do if the mouse hovers a wall in VisualisePlan uiState
    mouseHoverWall(wallHovered: Wall[], cursorPosition: math.vec3): boolean {
        // Parse wallHovered list
        for (var i = 0; i < wallHovered.length; i++) {
            // Get each wall node and mark them as hovered and in visualisation mode
            var wallNode = EntityManager.getInstance().getNode(wallHovered[i]);
            if (wallNode !== null) {
                wallNode.setHovered(true);
                wallNode.startVisualiseMode(wallHovered[i]);
            }
        }
        return true;
    }


    // What to do if the mouse leaves a wall hoevering
    mouseLeaveHoverWall(wallHovered: Wall[], cursorPosition: math.vec3): boolean {
        // Delete junction point if any
        GameObjectManager.deleteJunctionPoint('HoverJunctionPoint');
        // Parse wallHovered list
        for (var i = 0; i < wallHovered.length; i++) {
            // Get each wall node and mark them as not hovered anymore and in visualisation mode
            var wallNode = EntityManager.getInstance().getNode(wallHovered[i]);
            if (wallNode != null) {
                wallNode.setHovered(false);
                wallNode.endVisualiseMode(wallHovered[i]);
            }
        }
        return true;
    }

    // What to do if the mouse hovers a room
    mouseHoverRoom(room: Room, cursorPosition: math.vec3): boolean {
        // Get the room node and mark it as hovered
        var roomNode = EntityManager.getInstance().getNode(room);
        if (roomNode !== null) {
            roomNode.setHovered(true);
        }
        return true;
    }

    // What to do if the mouse leaves room hovering
    mouseLeaveHoverRoom(room: Room, cursorPosition: math.vec3): boolean {
        // Get the room node and mark it as not hovered anymore
        var roomNode = EntityManager.getInstance().getNode(room);
        if (roomNode !== null) {
            roomNode.setHovered(false);
        }
        return true;
    }

    // What to do if the mouse hovers a technical element
    mouseLeaveHoverTech(tech: TechnicalElement, cursorPosition: math.vec3): boolean {
        // Get the technical element node and mark it as hovered
        var techNode = EntityManager.getInstance().getNode(tech);
        if (techNode !== null) {
            techNode.setHovered(false);
        }
        return true;
    }

    // What to do if the mouse leaves technical element hovering
    mouseHoverTech(tech: TechnicalElement, cursorPosition: math.vec3): boolean {
        // Get the technical element node and mark it as not hovered anymore
        var techNode = EntityManager.getInstance().getNode(tech);
        if (techNode !== null) {
            techNode.setHovered(true);
        }
        return true;
    }

    // What to do if the mouse hovers a joinery
    mouseHoverJoinery(joinery: Joinery, cursorPosition: math.vec3): boolean {
        // Get the joinery node and mark it as hovered
        var joineryNode = EntityManager.getInstance().getNode(joinery);
        if (joineryNode !== null) {
            joineryNode.setHovered(true);
        }
        return true;
    }

    // What to do if the mouse leaves joinery hovering
    mouseLeaveHoverJoinery(joinery: Joinery, cursorPosition: math.vec3): boolean {
        // Get the joinery node and mark it as not hovered anymore
        var joineryNode = EntityManager.getInstance().getNode(joinery);
        if (joineryNode !== null) {
            joineryNode.setHovered(false);
        }
        return true;
    }

    // What to do if the mouse hovers a savane entity (can be arrangement object for instance)
    mouseHoverEntity(entityHovered: Entity, cursorPosition: math.vec3): boolean {
        // Get the entity node and mark it as hovered
        var entityNode = EntityManager.getInstance().getNode(entityHovered);
        if (entityNode !== null) {
            entityNode.setHovered(true);
        }
        return true;
    }

    // What to do if the mouse leaves savane entity hovering
    mouseLeaveHoverEntity(entityHovered: Entity): boolean {
        // Get the entity node and mark it as not hovered anymore
        var entityNode = EntityManager.getInstance().getNode(entityHovered);
        if (entityNode !== null) {
            entityNode.setHovered(false);
        }
        return true;
    }
}
